// Reads the resolved permission map delivered on userData (from /me and
// /signin) — see Tissue Vault BE auth/permissions/registry.ts for the
// source-of-truth list of keys.
export const hasPermission = (userData, key) => Boolean(userData?.Permissions?.[key]);
